<template>
  <b-button v-ripple v-bind="$attrs" v-on="$listeners">
    <b-spinner v-if="loading" small class="mr-1" :variant="spinnerVariant" />
    <i v-else-if="showIcon" class="icon" :class="icon"></i>
    <slot></slot>
  </b-button>
</template>

<script>
const spinnerVariants = {
  light: "dark",
  white: "dark",
  secondary: "primary",
};

export default {
  name: "AppButton",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    spinnerVariant() {
      return spinnerVariants[this.$attrs.variant] || "light";
    },
    showIcon() {
      return this.icon && !this.loading;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
}
</style>
